import { FileWarning, Landmark } from 'lucide-react';
import { formatCurrency } from '@/lib/utils';
import { Badge } from '@/components/ui/badge';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

export const PayrollPeriodWorkflowCard = ({ summary, monthLabel, year }) => (
  <Card className="rounded-xl border-slate-200 bg-white/90 shadow-sm" data-testid="payroll-period-workflow-card">
    <CardHeader className="space-y-1 pb-2">
      <CardTitle className="flex items-center gap-2 text-base"><FileWarning className="h-4 w-4" /> Folha do período</CardTitle>
      <CardDescription>{monthLabel} {year} · processamento salarial, confirmação e pagamento.</CardDescription>
    </CardHeader>
    <CardContent className="space-y-2 pt-0">
      <div className="rounded-xl border border-slate-200 bg-slate-50 px-3 py-2.5" data-testid="payroll-period-workflow-summary">
        <p className="text-xs uppercase tracking-[0.18em] text-slate-500">Estado actual</p>
        <p className="mt-1 text-sm font-semibold text-slate-900">{summary.periodState}</p>
        <div className="mt-2 grid gap-1.5 text-xs text-slate-700 sm:grid-cols-3">
          <div className="rounded-lg border border-slate-200 bg-white px-2.5 py-2">1. Gerar</div>
          <div className="rounded-lg border border-slate-200 bg-white px-2.5 py-2">2. Rever</div>
          <div className="rounded-lg border border-slate-200 bg-white px-2.5 py-2">3. Processar</div>
        </div>
      </div>
    </CardContent>
  </Card>
);

export const PayrollStateObligationsCard = ({ summary, title = 'INSS e IRPS do período', description = 'Consolidação contributiva do período para RH e finanças.' }) => (
  <Card className="rounded-xl border-slate-200 bg-white/90 shadow-sm" data-testid="payroll-state-obligations-card">
    <CardHeader className="space-y-1 pb-2">
      <CardTitle className="flex items-center gap-2 text-base"><Landmark className="h-4 w-4" /> {title}</CardTitle>
      <CardDescription>{description}</CardDescription>
    </CardHeader>
    <CardContent className="space-y-2 pt-0">
      <div className="grid gap-2 sm:grid-cols-3">
        <div className="rounded-xl border border-slate-200 bg-slate-50 px-3 py-2.5" data-testid="payroll-net-to-employee-card">
          <p className="text-xs uppercase tracking-[0.16em] text-slate-500">Líquido ao colaborador</p>
          <p className="mt-1 text-base font-semibold text-slate-900">{formatCurrency(summary.totals.netSalary)}</p>
        </div>
        <div className="rounded-xl border border-blue-200 bg-blue-50 px-3 py-2.5" data-testid="payroll-inss-state-card">
          <p className="text-xs uppercase tracking-[0.16em] text-blue-700">INSS a pagar ao Estado</p>
          <p className="mt-1 text-base font-semibold text-blue-900">{formatCurrency(summary.totals.inssState)}</p>
          <p className="mt-1 text-xs text-blue-700">Retido: {formatCurrency(summary.totals.inssEmployee)} · Patronal: {formatCurrency(summary.totals.inssEmployer)}</p>
        </div>
        <div className="rounded-xl border border-purple-200 bg-purple-50 px-3 py-2.5" data-testid="payroll-irps-state-card">
          <p className="text-xs uppercase tracking-[0.16em] text-purple-700">IRPS a pagar ao Estado</p>
          <p className="mt-1 text-base font-semibold text-purple-900">{formatCurrency(summary.totals.irps)}</p>
        </div>
      </div>
      <div className="flex flex-wrap gap-2 text-xs" data-testid="payroll-due-dates-strip">
        <Badge variant="outline" className="rounded-full bg-blue-50 text-blue-700">INSS até {summary.dueDates.inss}</Badge>
        <Badge variant="outline" className="rounded-full bg-purple-50 text-purple-700">IRPS até {summary.dueDates.irps}</Badge>
      </div>
      {summary.irpsPending && (
        <div className="rounded-xl border border-amber-200 bg-amber-50 px-3 py-2.5 text-sm text-amber-800" data-testid="payroll-irps-pending-card">
          <p className="font-medium">IRPS pendente de tabela activa</p>
          <p className="mt-1 text-xs">{summary.irpsNote}</p>
        </div>
      )}
    </CardContent>
  </Card>
);